export const LAYOUT_RESIZED      = 'layout/resized';
export const LAYOUT_CHANGED_POINT= 'layout/changed_point';


export const AUTH_LOADING        = 'auth/loading';
export const AUTH_LOADED         = 'auth/loaded';
export const AUTH_AUTHENTICATED  = 'auth/authenticated';
export const AUTH_DISCONNECTED   = 'auth/disconnected';
export const CHANGED_TAC         = 'auth/tac';
export const CHANGED_TAC_INFO    = 'auth/tac-info';
export const LOCALIZATION_LOADED = 'l10n/loaded';

export const LANGUAGES_LOADED    = 'languages/loaded';

export const USERS_CHANGED_CURRENT  = 'users/changed_current';


export const SETTINGS_CHANGED    = 'settings/changed';


export const SHOW_LOADING     = 'show/loading';
export const SHOW_LOADED      = 'show/loaded';
export const SHOW_CLEARED     = 'show/cleared';
export const SHOW_NOT_FOUND   = 'show/not-found';

export const SHOWS_LOADING    = 'shows/loading';
export const SHOWS_LOADED     = 'shows/loaded';


export const CLIPS_LOADING    = 'clips/loading';
export const CLIPS_LOADED     = 'clips/loaded';
export const CLIPS_SEARCHING  = 'clips/searching';

export const CLIPS_RESETED_FILTER      = 'clips/reseted_filter';
export const CLIPS_RESETED_FACETS      = 'clips/reseted_facets';
export const CLIPS_PAGE_CHANGED        = 'clips/changed_page';
export const CLIPS_PAGE_SIZE_CHANGED   = 'clips/changed_page_size';
export const CLIPS_RESELECTED_FACETS   = 'clips/reselected_facets';
export const SEARCH_CHANGING_TYPE      = 'search/changing_type';
export const SEARCH_CHANGED_FIELDS     = 'search/changed_fields';
export const CHANGED_SEARCH_COUNTER    = 'search/changed_counter';
export const CLIPS_CHANGED_CURRENT_FACETS = 'clips/all_facets';
export const SEARCH_STATE_CHANGED      = 'search/state-changed';


export const REMOVED_FROM_CART   = 'cart/removed_clip';
export const REMOVED_CART        = 'cart/remove';
export const ADDED_TO_CART       = 'cart/added';
export const CART_LOADING        = 'cart/loading';
export const CART_LOADED         = 'cart/loaded';
export const CART_UPLOADING_CLIP = 'cart/uploading_clip';
export const REFRESH_CART        = 'cart/change';
export const CHANGED_CART_PAGE   = 'cart/changed-page';
export const CART_SHARED         = 'cart/shared';
export const CART_UNSHARED       = 'cart/unshared';

export const CHANGED_SEARCH_MODE = 'search/changed_mode';

export const EPISODE_LOADING     = 'episode/loading';
export const EPISODE_LOADED      = 'episode/loaded';

export const ADDED_NOTIFICATION     = 'notification/added';
export const REMOVED_NOTIFICATION   = 'notification/removed';

export const POPUP_OPENED = 'popup/opened';
export const POPUP_CLOSED = 'popup/closed';

export const ROUTE_CHANGED = 'route/changed';
